// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".AddToWallet-module-walletButton-3IpcQ{display:flex;border:none;background:none;cursor:pointer}.AddToWallet-module-walletButton-3IpcQ:disabled{opacity:.5;cursor:default}", ""]);
// Exports
exports.locals = {
	"walletButton": "AddToWallet-module-walletButton-3IpcQ"
};
module.exports = exports;
